import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Route, Redirect } from 'react-router-dom'
import { localGet, localRemove } from '../../lib/session'
import { setStatusAuth } from '../../actions/user'

class PrivateRoute extends Component {
  render() {
    const rest = {
      name: this.props.name,
      path: this.props.path,
      location: this.props.location,
      computedMatch: this.props.computedMatch
    }

    const auth = !this.props.authUser.state && this.props.authUser.data != null
    const sessionAuth = localGet('AUTH_TOKEN')

    if (auth) {
      return <Route {...rest} component={this.props.component} />
    }

    if (sessionAuth) {
      this.props.setStatusAuth(sessionAuth)
      return null
    }

    localRemove('TERM')
    return <Redirect to={{ pathname: '/login' }} />
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ setStatusAuth }, dispatch)

const mapStateToProps = (state) => ({
  authUser: state.userState.authUser
})

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)
